import { render, staticRenderFns } from "./VformSidePanelDraggableDroppableMixin.js.vue?vue&type=template&id=02df28de&"
import script from "./VformSidePanelDraggableDroppableMixin.js.vue?vue&type=script&lang=js&"
export * from "./VformSidePanelDraggableDroppableMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports